var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-70.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_logo",
    transform: "translate(70.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9375,2.69146423 L12.9375,11.6470588 C12.9375,12.2683792 12.4338203,12.7720588 11.8125,12.7720588 L2.74090029,12.7720588 C2.11957995,12.7720588 1.61590029,12.2683792 1.61590029,11.6470588 C1.61590029,11.3461809 1.73642309,11.0578406 1.95054054,10.8464613 L11.0221403,1.89086666 C11.4642981,1.45436302 12.1765939,1.45894665 12.6130976,1.90110448 C12.8209522,2.11165152 12.9375,2.39560345 12.9375,2.69146423 Z",
    id: "Triangle",
    fill: "#10BAD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625,14.2279412 C24.8676407,14.2279412 25.875,15.2353005 25.875,16.4779412 L25.875,23.625 C25.875,24.8676407 24.8676407,25.875 23.625,25.875 L16.625,25.875 C15.3823593,25.875 14.375,24.8676407 14.375,23.625 L14.375,16.4779412 C14.375,15.2353005 15.3823593,14.2279412 16.625,14.2279412 L23.625,14.2279412 Z M10.6875,14.2279412 C11.9301407,14.2279412 12.9375,15.2353005 12.9375,16.4779412 L12.9375,23.625 C12.9375,24.8676407 11.9301407,25.875 10.6875,25.875 L3.6875,25.875 C2.44485931,25.875 1.4375,24.8676407 1.4375,23.625 L1.4375,16.4779412 C1.4375,15.2353005 2.44485931,14.2279412 3.6875,14.2279412 L10.6875,14.2279412 Z M23.625,1.125 C24.8676407,1.125 25.875,2.13235931 25.875,3.375 L25.875,10.5220588 C25.875,11.7646995 24.8676407,12.7720588 23.625,12.7720588 L16.625,12.7720588 C15.3823593,12.7720588 14.375,11.7646995 14.375,10.5220588 L14.375,3.375 C14.375,2.13235931 15.3823593,1.125 16.625,1.125 L23.625,1.125 Z",
    id: "Combined-Shape",
    fill: "#19E5F0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.b481fb7940fa565679dea86a5cd71b2a.svg";
export { ForwardRef as ReactComponent };